import axios from 'axios'
import { store } from '@/setup/store'

// url del api
let apiUrl = 'https://api-eventhub.dexservices.com.ar/api/v1/'
// const host = location.hostname

// // Se usa el mismo entorno para el cliente y segun URL redirige las respuestas a diferentes APIS
// if (host.endsWith("veranocarshow.com.ar") || host.endsWith("summercarshow.com.ar")) {
//   apiUrl = 'https://api.eventhub.la/api/v1/'
// }

// // Esto define un dominio que funcionará como testeo  por el momento le pega al de produccion
// if (location.hostname.endsWith(".eventhub.la")) {
//   apiUrl = 'https://api.eventhub.la/api/v1/'
// }

let option = { baseURL: apiUrl }

const CancelToken = axios.CancelToken
const instance = axios.create(option)

instance.interceptors.request.use(
  function (config) {
    if (typeof store.state.locale !== 'undefined') {
      Object.assign(config.headers, { 'Accept-Language': store.state.locale })
    }

    if (typeof store.state.authUser?.token !== 'undefined') {
      Object.assign(config.headers, {
        Authorization: 'Bearer ' + store.state.authUser.token
      })
    }

    // Creamos un nuevo Source para cada paticion y asi permitir la cancelación
    const source = CancelToken.source()
    Object.assign(config, { cancelToken: source.token })

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default instance
